import { TermSuggestionPayload } from '../dynamicTermSuggestion.types';

export const prepareTermSuggestionPayload = ({
  keys,
  origin,
}: {
  keys: string[];
  origin: string;
}): TermSuggestionPayload => ({
  origin,
  terms: keys.map((key) => ({ key })),
});
